import React from 'react';
import { useRecordContext } from 'react-admin';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { IconButton as MuiIconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const EnrichedField = () => {
    const record = useRecordContext()
    const [dialogOpen, setDialogOpen] = React.useState(false)

    if (!record?.has_ai_summary) {
        return null;
    }

    return (
        <>
            <MuiIconButton
                size="small"
                onClick={() => setDialogOpen(true)}
                sx={{ color: 'success.main', p: 0.5 }}
                title="View AI Summary"
            >
                <AutoFixHighIcon fontSize="small" />
            </MuiIconButton>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>AI Summary</DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                        {record.ai_summary}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default EnrichedField;
